import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'MdmModal',
  props: {
    showModal: {
      type: Boolean,
      required: true
    },
    withCloseLabel: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      lastFocus: null
    };
  },
  mounted: function mounted() {
    if (this.showModal === true) {
      this.disableWindowScroll();
    }
  },
  destroyed: function destroyed() {
    this.enableWindowScroll();
  },
  updated: function updated() {
    if (this.showModal) {
      // disable scroll when modal is open
      this.disableWindowScroll(); // save last focused element and focus on the modal

      this.lastFocus = document.activeElement;
    } else if (this.lastFocus) {
      this.enableWindowScroll(); // focus on last focused element

      this.lastFocus.focus();
    }
  },
  methods: {
    close: function close() {
      this.$emit('onclosemodal');
      this.enableWindowScroll();
    },
    handleFocus: function handleFocus(evt) {
      // keep focus inside the modal (focus trap for a11y)
      if (!this.$el.contains(evt.relatedTarget)) {
        this.$el.focus();
      }
    }
  }
};